import { Injectable } from '@angular/core';
import { distinctUntilChanged, filter, Observable, Subject } from "rxjs";
import {ScrollEvent} from "../../types/table-types/scroll-sync.types";


@Injectable({
  providedIn: 'root'
})
export class ScrollSyncService {
  private scrollSubjects = new Map<string, Subject<ScrollEvent>>();

  public scroll(source: string, scrollLeft: number, group: string = 'default'): void {
    this.getSubject(group)?.next({ source, scrollLeft, group });
  }

  public getScrollEvents(excludeSource: string, group: string = 'default'): Observable<ScrollEvent> | undefined {
    return this.getSubject(group)?.asObservable().pipe(
      filter(event => event.source !== excludeSource),
      distinctUntilChanged((prev, curr) => prev.scrollLeft === curr.scrollLeft)
    );
  }

  private getSubject(group: string): Subject<ScrollEvent> | undefined {
    if (!this.scrollSubjects.has(group)) {
      this.scrollSubjects.set(group, new Subject<ScrollEvent>());
    }

    return this.scrollSubjects.get(group);
  }

  destroyGroup(group: string) {
    this.scrollSubjects.get(group)?.complete();
    this.scrollSubjects.delete(group);
  }
}
